// ko strings for messages/studioOptions.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studioOptions: Dict = {
  // Sound sheet
  "studioOptions.pitch.title": "피치",
  "studioOptions.pitch.hint":
    "반음 단위예요. 남성 목소리를 여성 목소리로 바꾸나요? +12를 써 보세요.",
  // aria-label: "{name} 피치 낮추기" (stepper.lower wraps this)
  "studioOptions.pitch.label": "{name} 피치",
  "studioOptions.pitch.maleToFemale": "남성 → 여성",
  "studioOptions.pitch.femaleToMale": "여성 → 남성",
  "studioOptions.pitch.original": "원래대로",
  "studioOptions.stepper.lower": "{label} 낮추기",
  "studioOptions.stepper.raise": "{label} 높이기",
  "studioOptions.effect.title": "효과",
  "studioOptions.effect.hint": "한 번에 하나만 적용돼요. 다시 탭하면 해제돼요.",
  "studioOptions.effect.none": "없음",
  "studioOptions.effect.onVocals": "보컬에 적용",
  "studioOptions.effect.onSong": "노래 전체에 적용",
  "studioOptions.autotune.title": "오토튠",
  "studioOptions.autotune.switch": "보컬을 키에 맞추기",
  "studioOptions.autotune.hint": "살짝 다듬는 느낌부터 확실한 로봇 사운드까지.",
  "studioOptions.autotune.light": "약하게",
  "studioOptions.autotune.medium": "보통",
  "studioOptions.autotune.strong": "강하게",
  "studioOptions.mix.title": "믹스",
  "studioOptions.mix.vocalVolume": "보컬 볼륨",
  "studioOptions.mix.vocalVolumeHint": "음악보다 크게 또는 작게 (dB 단위).",
  // aria-label: "보컬 볼륨 낮추기"
  "studioOptions.mix.vocalVolumeLabel": "보컬 볼륨",
  "studioOptions.mix.backing": "백보컬 분리",
  "studioOptions.mix.backingHint":
    "화음이나 애드리브가 있는 노래라면 결과가 더 깔끔해져요.",
  "studioOptions.mix.vocalsOnly": "보컬만 있는 오디오예요",
  "studioOptions.mix.vocalsOnlyHint":
    "음악에서 보컬을 분리하는 단계를 건너뛰어요.",
  "studioOptions.name.title": "커버 이름",
  "studioOptions.name.placeholder": "선택 사항",

  // The Sound card's one-line summary
  "studioOptions.summary.pitch": "피치 {values}",
  "studioOptions.summary.autotune": "오토튠",
  "studioOptions.summary.vocals": "보컬 {value}",
  "studioOptions.summary.backing": "백보컬 분리",
  "studioOptions.summary.vocalsOnly": "보컬 전용 입력",
  "studioOptions.summary.default": "원래 피치, 효과 없음",

  // Video sheet (Marble Run)
  "studioOptions.video.previewAria": "Marble Run 미리보기",
  "studioOptions.video.headline":
    "목소리들이 레이스를 펼쳐요. 앞선 목소리가 노래해요.",
  "studioOptions.video.body":
    "선두가 바뀌면 목소리도 바뀌고, 가사가 화면에 표시돼요. 틱톡과 릴스에 바로 올릴 수 있어요.",
  "studioOptions.video.crown": "왕관이 지금 부르는 목소리를 알려 줘요",
  "studioOptions.video.pickLook": "테마 선택",
  "studioOptions.video.customise": "직접 꾸미기",
  "studioOptions.video.surprise": "랜덤으로",
  "studioOptions.video.marbles": "구슬과 트랙",
  "studioOptions.video.sky": "하늘",
  "studioOptions.video.font": "가사 글꼴",
  "studioOptions.video.stars": "하늘의 별",
  "studioOptions.theme.midnight": "미드나잇",
  "studioOptions.theme.neon": "네온",
  "studioOptions.theme.ocean": "오션",
  "studioOptions.theme.royal": "로열",
  "studioOptions.theme.lava": "라바",
  "studioOptions.theme.gold": "골드",

  // Upload view
  "studioOptions.upload.empty":
    "빈 파일이에요. 노래 파일을 다시 선택해 주세요.",
  "studioOptions.upload.tooBig":
    "파일 크기가 75MB를 넘어요! 더 작은 파일을 업로드해 주세요.",
  "studioOptions.upload.tooLong":
    "오디오 길이가 6분을 넘어요! 더 짧은 파일을 업로드해 주세요.",
  "studioOptions.upload.invalid": "올바른 오디오 파일을 업로드해 주세요",
  "studioOptions.upload.unexpected": "예기치 않은 오류가 발생했어요.",
  "studioOptions.upload.uploading": "업로드 중...",
  "studioOptions.upload.coverAlt": "커버",
  "studioOptions.upload.dropIt": "여기에 놓으세요",
  "studioOptions.upload.dropHere": "오디오를 여기에 끌어다 놓으세요",
  "studioOptions.upload.browse": "파일 찾아보기",
  "studioOptions.upload.formats": "MP3, WAV, M4A · 최대 6분",
  "studioOptions.upload.dropOrBrowse":
    "오디오 파일을 끌어다 놓거나 클릭해서 찾아보세요",
  "studioOptions.upload.limits": "최대 75MB, 6분 • MP3, WAV, M4A",

  // Record view
  "studioOptions.mic.denied":
    "녹음하려면 브라우저에서 마이크 접근을 허용해 주세요.",
  "studioOptions.mic.notFound": "녹음할 마이크를 찾지 못했어요.",
  "studioOptions.mic.prepareFailed": "업로드 위치를 준비하지 못했어요.",
  "studioOptions.mic.fileFailed": "파일을 업로드하지 못했어요.",
  "studioOptions.mic.uploadFailed": "녹음 파일 업로드에 실패했어요.",
  "studioOptions.mic.previewFailed": "미리 듣기를 재생할 수 없어요.",
  "studioOptions.mic.start": "녹음 시작",
  "studioOptions.mic.stop": "녹음 중지",
  "studioOptions.mic.tapRecord": "탭해서 녹음",
  "studioOptions.mic.tapStop": "탭해서 중지",
  "studioOptions.mic.clickRecord": "클릭해서 녹음",
  "studioOptions.mic.processing": "처리 중...",
  "studioOptions.mic.playPreview": "미리 듣기",
  "studioOptions.mic.pausePreview": "미리 듣기 일시정지",
  "studioOptions.mic.yourRecording": "내 녹음",
  "studioOptions.mic.use": "이 녹음 사용",
  "studioOptions.mic.again": "다시 녹음",
  "studioOptions.mic.continue": "계속",
};

export default studioOptions;
